// List matches backend features list
// See app/lib/features.rb
export const COUNTRY_BLOCKING_FEATURE = "country_blocking"
export const METABASE_DASHBOARD_EXPORTING_FEATURE = "metabase_dashboard_exporting"
export const REPORTING_FEATURE = "reporting"
export const FORM_FILE_UPLOADS_FEATURE = "form_file_uploads"
